<div class="flex justify-between items-center ">
	<div class="flex justify-start items-center font-bold gap-2">
		<fb-product-currency-dropdown></fb-product-currency-dropdown>
		<div *ngIf="!discountedPrice"
			 class="text-xl text-[#3c3c3c]">{{(price? price: product.price) |  currencyConverter | number: '1.0-2'}}</div>
		<div *ngIf="discountedPrice" class="flex justify-start items-center">
			<div class="line-through text-sm text-[#898E9A]">{{(price? price: product.price) |  currencyConverter | number: '1.0-2'}}</div>
			<div class="text-xl text-[#3c3c3c] ml-2">{{(discountPriceForView) |  currencyConverter | number: '1.0-2'}}</div>
		</div>
		<div class="text-[#898E9A] text-xs capitalize">/   {{product.unit.toLowerCase() }}</div>
	</div>
	<div class="relative fb-price-detail hidden md:block">
		<div class="fb-price-detail-btn cursor-pointer underline font-semibold text-[12px] text-[#6B7280]">
			View Price Details
		</div>
		<div class="fb-price-summary absolute top-5 right-0 z-10 text-xs bg-gray-100 w-[250px] p-2 rounded">
			<div class="text-sm font-semibold mb-1">Price Summary</div>
			<div *ngIf="product.productGroup === 'finished'" class="flex flex-col gap-1">

				<div *ngIf="priceSummary.consumedFabric" class="flex justify-between">
					<div>Fabric Consumption: </div>
					<div>{{priceSummary.consumedFabric}} meter(s)</div>
				</div>
				<div *ngIf="priceSummary.fabric" class="flex justify-between">
					<div>Fabric Cost:</div>
					<div>{{selectedCurrency | uppercase}} {{priceSummary.fabric |  currencyConverter | number: '1.0-2'}}</div>
				</div>
				<div class="flex justify-between">
					<div>Making Cost:</div>
					<div>{{selectedCurrency | uppercase}} {{priceSummary.makingCharges |  currencyConverter | number: '1.0-2'}}</div>
				</div>
				<div *ngIf="priceSummary.finish" class="flex justify-between">
					<div>Finishing Cost:</div>
					<div>{{selectedCurrency | uppercase}} {{priceSummary.finish |  currencyConverter | number: '1.0-2'}}</div>
				</div>
				<div *ngIf="priceSummary.customSize" class="flex justify-between">
					<div>Custom Size Cost:</div>
					<div>{{selectedCurrency | uppercase}} {{priceSummary.customSize |  currencyConverter | number: '1.0-2'}}</div>
				</div>

				<div class="flex justify-between border-t pt-1 border-gray-300">
					<div class="font-semibold">Total:</div>
					<div>{{selectedCurrency | uppercase}} {{(price? price: product.price) |  currencyConverter | number: '1.0-2'}}</div>
				</div>
			</div>
			<div *ngIf="product.productGroup !== 'finished'" class="flex flex-col gap-1">
				<div class="flex justify-between">
					<div>Base Fabric Cost:</div>
					<div>{{selectedCurrency | uppercase}} {{product.madeToOrderProfileEnabled? priceSummary.fabric: product.price |  currencyConverter | number: '1.0-2'}}</div>
				</div>
				<div *ngIf="priceSummary.finish" class="flex justify-between">
					<div>Finishing Cost:</div>
					<div>{{selectedCurrency | uppercase}} {{priceSummary.finish |  currencyConverter | number: '1.0-2'}}</div>
				</div>
				<div *ngIf="priceSummary.customSize" class="flex justify-between">
					<div>Custom Dye Cost:</div>
					<div>{{selectedCurrency | uppercase}} {{priceSummary.customSize |  currencyConverter | number: '1.0-2'}}</div>
				</div>
				<div *ngIf="product.madeToOrderProfileEnabled && priceSummary.makingCharges" class="flex justify-between">
					<div>Craft Cost:</div>
					<div>{{selectedCurrency | uppercase}} {{priceSummary.makingCharges |  currencyConverter | number: '1.0-2'}}</div>
				</div>
				<div class="flex justify-between border-t pt-1 border-gray-300">
					<div class="font-semibold">Total:</div>
					<div>{{selectedCurrency | uppercase}} {{(price? price: product.price) |  currencyConverter | number: '1.0-2'}}</div>
				</div>
			</div>
		</div>
	</div>

</div>
